import Delete from '@mui/icons-material/Delete';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';

export type ContextMenuDeleteButtonProps = Omit<
  ContextMenuButtonProps,
  'icon' | 'label' | 'onClick'
> & {
  onClick: NonNullable<ContextMenuButtonProps['onClick']>;
};

export const ContextMenuDeleteButton: React.FC<ContextMenuDeleteButtonProps> = ({
  onClick,
  ...restProps
}) => {
  const translate = useTypedTranslate();
  const { onCloseMenu } = useContextMenuContext();

  const handleClick = () => {
    onClick();
    onCloseMenu();
  };

  return (
    <ContextMenuButton
      icon={<Delete fontSize="medium" />}
      label={translate('app.buttons.delete')}
      {...restProps}
      onClick={handleClick}
    />
  );
};
